export default __webpack_public_path__ + "2572adcf5e696885a7422e81d6867f07.svg";